/**
 * Created by daniesy on 21/11/2016.
 */
import {csvParse} from "./csvParse";
import dsv from './dsv';

export default dsv("text/csv", csvParse);


// WEBPACK FOOTER //
// ./src/js/tools/csv.js